import 'css-chunksrc/client/pages/searchPage/searchResults/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_m3xwb_1",
  "allocation": "_allocation_m3xwb_1"
};